<div class="p-grid">
	<div class="p-col-12 p-lg-4 d-flex flex-column">
		<div>Order Lead Time (minutes)</div>
		<div class="mb-3">
			<p-inputNumber (onInput)="changesToSaveChange.emit(true)" [(ngModel)]="venueSvc.ooVenue.orderLeadTime"></p-inputNumber>
		</div>
	</div>
	<div class="p-col-12 p-lg-4 d-flex flex-column">
		<div>Tax Rate</div>
		<div class="mb-3">
			<p-inputNumber
				(onInput)="changesToSaveChange.emit(true)"
				[(ngModel)]="venueSvc.ooVenue.taxRate"
				mode="decimal"
				suffix="%"
				[minFractionDigits]="2"
				[maxFractionDigits]="4"
			></p-inputNumber>
		</div>
	</div>
	<div class="p-col-12 p-lg-4 d-flex flex-column">
		<div>Future Order Mode</div>
		<div class="mb-3">
			<p-dropdown
				[options]="[
					{ label: 'ASAP Only', value: 0 },
					{ label: 'Today Only', value: 1 },
					{ label: 'Today and Future', value: 2 }
				]"
				[autoDisplayFirst]="false"
				placeholder="Select Mode"
				[baseZIndex]="10000"
				appendTo="body"
				[(ngModel)]="venueSvc.ooVenue.futureOrderMode"
				(onChange)="changesToSaveChange.emit(true)"
				[style]="{ width: '100%' }"
			>
			</p-dropdown>
		</div>
		<div *ngIf="venueSvc.ooVenue.futureOrderMode === 2">Future Order Threshold (days)</div>
		<div class="mb-3" *ngIf="venueSvc.ooVenue.futureOrderMode === 2">
			<p-inputNumber (onInput)="changesToSaveChange.emit(true)" [(ngModel)]="venueSvc.ooVenue.futureOrderThreshold" styleClass="w-100"> </p-inputNumber>
		</div>
		<div>Order Queue Mode</div>
		<div class="mb-3">
			<p-dropdown
				[options]="[
					{ label: 'Immediate', value: 1 },
					{ label: 'Day of', value: 2 },
					{ label: 'Time of', value: 3 }
				]"
				[autoDisplayFirst]="false"
				placeholder="Select Mode"
				[baseZIndex]="10000"
				appendTo="body"
				[style]="{ width: '100%' }"
				(onChange)="changesToSaveChange.emit(true)"
				[(ngModel)]="venueSvc.ooVenue.orderQueueMode"
			>
			</p-dropdown>
		</div>
		<div *ngIf="venueSvc.ooVenue.orderQueueMode === 2">Order Queue Daily Time</div>
		<div class="mb-3" *ngIf="venueSvc.ooVenue.orderQueueMode === 2">
			<p-calendar
				(onInput)="changesToSaveChange.emit(true)"
				(onSelect)="changesToSaveChange.emit(true)"
				[(ngModel)]="venueSvc.ooVenue.orderQueueDailyTime"
				showTime="true"
				hourFormat="24"
				timeOnly="true"
				dataType="string"
				showSeconds="true"
			>
			</p-calendar>
		</div>
	</div>
</div>
